












































































































import Vue from 'vue';
import UploadSaveData from '@/components/saveData/UploadSaveData.vue';
import Convert from '@/classes/convert';
import SaveData from '@/classes/saveData/saveData';
import FirebaseManager from '@/classes/firebaseManager';
import LZString from 'lz-string';

export default Vue.extend({
  name: 'ShareDialog',
  components: { UploadSaveData },
  props: {
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    loadingURL: false,
    loadingTwitter: false,
    createdURL: '',
    copiedURLHint: '',
    copiedDeckHint: '',
    uploadDialog: false,
    dataName: '',
    dataRemarks: '',
  }),
  computed: {
    saveData(): SaveData | undefined {
      const saveData = this.$store.state.mainSaveData as SaveData;
      if (!saveData) {
        return undefined;
      }
      return saveData;
    },
    deckBuilder(): string {
      const saveData = this.$store.state.mainSaveData as SaveData;
      if (!saveData) {
        return '';
      }
      const manager = saveData.tempData[saveData.tempIndex];
      if (!manager) {
        return '';
      }
      return Convert.createDeckBuilderToString(manager, this.$store.state.cellInfos);
    },
    compressFleetOnlyDeckBuilder() {
      const saveData = this.$store.state.mainSaveData as SaveData;
      if (!saveData) {
        return '';
      }
      const manager = saveData.tempData[saveData.tempIndex];
      if (!manager) {
        return '';
      }
      const deck = Convert.createDeckBuilder(manager, this.$store.state.cellInfos);
      delete deck.a1;
      delete deck.a2;
      delete deck.a3;
      delete deck.s;
      return LZString.compressToEncodedURIComponent(JSON.stringify(deck));
    },
  },
  methods: {
    inform(message: string, isError: boolean) {
      return this.$emit('inform', message, isError);
    },
    close() {
      this.handleClose();
    },
    createURL() {
      this.loadingURL = true;
      const url = this.getLongSaveDataURL();
      // URL取得要求
      FirebaseManager.getShortURL(url).then((shortUrl) => {
        if (shortUrl) {
          this.createdURL = shortUrl;
        } else {
          this.createdURL = 'URLの発行に失敗しました。';
        }
        this.loadingURL = false;
      });
    },
    shareTwitter() {
      this.loadingTwitter = true;
      const url = this.getLongSaveDataURL();
      // URL取得要求
      FirebaseManager.getShortURL(url).then((shortUrl) => {
        if (shortUrl) {
          window.open(`https://twitter.com/share?url=${shortUrl}`);
          this.loadingTwitter = false;
        }
      });
    },
    copyURL() {
      const textToCopy = document.getElementById('createdURL') as HTMLInputElement;
      textToCopy.select();
      document.execCommand('copy');
      this.copiedURLHint = 'コピーされました。';
    },
    copyDeckBuilder() {
      const textToCopy = document.getElementById('deck-builder-text') as HTMLInputElement;
      textToCopy.select();
      document.execCommand('copy');
      this.copiedDeckHint = 'コピーされました。';
    },
    clearURLHint() {
      this.copiedURLHint = '';
    },
    clearDeckHint() {
      this.copiedDeckHint = '';
    },
    getLongSaveDataURL(): string {
      const saveData = this.$store.state.mainSaveData as SaveData;
      if (!saveData || !saveData.tempData[saveData.tempIndex]) {
        return '';
      }
      const data = saveData.createURLSaveDataString();
      if (data) {
        return `${document.location.protocol}//${document.location.host}${document.location.pathname}?data=${data}`;
      }
      return '';
    },
    async showUploadDialog() {
      if (this.saveData) {
        this.dataName = this.saveData.name.trim();
        this.dataRemarks = this.saveData.remarks ? this.saveData.remarks.trim() : '';
        await (this.uploadDialog = true);
        const form = this.$refs.uploadSaveDataComp as InstanceType<typeof UploadSaveData>;
        if (form) {
          form.initControl();
        }
      }
    },
    closeEditDialog() {
      this.uploadDialog = false;
    },
  },
});
